import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const testimonials = [
  {
    name: "Sarah Mitchell",
    designation: "Home User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "My inkjet printer arrived quickly and was incredibly easy to set up. The print quality is amazing and perfect for my family’s everyday needs.",
  },
  {
    name: "Michael Carter",
    designation: "Small Business Owner",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Finally found a printer that fits my office workload. The comparison tools and expert advice made the decision effortless.",
  },
  {
    name: "Jessica Lopez",
    designation: "Frequent Printer User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Great selection, great prices. The ordering process was smooth and my printer worked perfectly right out of the box.",
  },
  {
    name: "Daniel Roberts",
    designation: "IT Professional",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Clear product specifications and fast delivery. This store is now my preferred source for office printers.",
  },
  {
    name: "Emma Williams",
    designation: "Teacher",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Perfect for my classroom — fast, quiet, and reliable. The customer support experience was excellent.",
  },
  {
    name: "James Parker",
    designation: "Home Office User",
    image: "/assets/img/icon/user-avatar.svg",
    text: "Support answered all my questions immediately. My new wireless printer is smooth and effortless to use.",
  },
];

function TestimonialOne() {
  return (
    <section className="testimonial-modern">
      <div className="tm-container">
        {/* Heading */}
        <div className="tm-heading">
          <h2>What Our Customers Are Saying</h2>
          <p>
            Real experiences from real users who trust our printing solutions
            for work, home, and everything in between.
          </p>
        </div>

        {/* Slider (NO DOTS, AUTO SLIDE) */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          className="tm-swiper"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="tm-card">
                <div className="tm-profile">
                  <img src={item.image} alt="avatar" />
                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.designation}</span>
                  </div>
                </div>

                <p className="tm-text">{item.text}</p>

                <div className="tm-quote">“</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* === Scoped CSS === */}
      <style>{`
        .testimonial-modern {
          padding: 90px 0;
          background: #f8fafc;
        }

        .testimonial-modern .tm-container {
          max-width: 1200px;
          margin: auto;
          padding: 0 20px;
        }

        /* Heading */
        .testimonial-modern .tm-heading {
          text-align: center;
          margin-bottom: 50px;
        }

        .testimonial-modern .tm-heading h2 {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .testimonial-modern .tm-heading p {
          font-size: 16px;
          color: #64748b;
          max-width: 600px;
          margin: auto;
        }

        /* Card */
        .testimonial-modern .tm-card {
          background: rgba(255,255,255,0.75);
          backdrop-filter: blur(8px);
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 28px;
          position: relative;
          transition: 0.3s ease;
          height: 100%;
        }

        .testimonial-modern .tm-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
        }

        /* Profile */
        .testimonial-modern .tm-profile {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 18px;
        }

        .testimonial-modern .tm-profile img {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: #fff;
          padding: 6px;
          border: 1px solid #e5e7eb;
        }

        .testimonial-modern .tm-profile h4 {
          margin: 0;
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
        }

        .testimonial-modern .tm-profile span {
          font-size: 14px;
          color: #64748b;
        }

        /* Text */
        .testimonial-modern .tm-text {
          font-size: 15px;
          line-height: 1.6;
          color: #475569;
          margin-bottom: 20px;
          min-height: 90px;
        }

        /* Quote */
        .testimonial-modern .tm-quote {
          position: absolute;
          bottom: 18px;
          right: 22px;
          font-size: 48px;
          color: #d1d5db;
          font-weight: 700;
        }
      `}</style>
    </section>
  );
}

export default TestimonialOne;
